<div class="card fill-height fill-height-bg">
  <div class="card-body py-lg-5">
    <h3 class="text-center mb-lg-5">Please select your organisation.</h3>
    <div class="row justify-content-center mb-4">
      <div class="col-md-6 col-xl-5 col-xxl-4">
        <div class="card shadow-lg">
          <div class="card-body">
            @if (accountingProvider()) {
              @if (showError) {
                <div class="alert alert-danger">
                  {{ showError }}
                </div>
              }
              @if (accountingProvider() === AccountingProviderCompany.XERO) {
                <div class="mb-3">
                  <img
                    src="./assets/accounting-logos/xero-select-tenant.svg"
                    width="100%"
                    alt="Xero" />
                </div>
              }
              <p class="text-muted my-3">Paystashio would like access to your {{ accountingProvider() }} data</p>
              @if (hasTenants()) {
                <label
                  class="form-label"
                  for="select_tenant">
                  Organisation
                </label>
                <ng-select
                  [id]="'select_tenant'"
                  [items]="tenantOptions"
                  [(ngModel)]="selectedTenant"
                  bindValue="id"
                  bindLabel="name"
                  notFoundText="No organisations found"
                  placeholder="Select your organisation">
                </ng-select>
                <button
                  (click)="onSave()"
                  class="btn btn-primary mt-3 d-block w-100"
                  [disabled]="!selectedTenant">
                  Allow access
                </button>
              }
              @if (isPending()) {
                @if (!hasTenants()) {
                  <div class="alert alert-light mb-3">This step has been completed.</div>
                }
              }
              @if (isCompleted()) {
                @if (!hasTenants()) {
                  <div class="alert alert-light">This step has been completed.</div>
                }
              } @else if (hasStatusError()) {
                <p class="alert alert-danger mb-0">
                  An error was detected with your accounting connection.
                  <button
                    class="btn-reset btn-link d-inline fw-medium text-danger w-auto"
                    (click)="onReconnect()">
                    Reconnect
                  </button>
                </p>
              }
            } @else {
              <app-loader class="my-5"></app-loader>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
